import Button from "@mui/material/Button"
import {styled} from "@mui/material/styles"

type StyledFacetsButtonProps = {
    large?: boolean
}

export const StyledFacetsButton: any = styled(Button, {shouldForwardProp: p => p !== "large"})<StyledFacetsButtonProps>`
    & {
        color: ${props =>
            props.large
                ? (props.theme.colours.form.buttonPrimary.color as string)
                : (props.theme.colours.text.hyperlink as string)};
        background-color: ${props =>
            props.large ? (props.theme.colours.form.buttonPrimary.background as string) : "transparent"};
        min-width: auto;
        max-width: 16.25rem;

        padding-left: 0;
        justify-content: flex-start;
        text-align: left;
        overflow-anchor: none;
        border: ${props => props.theme.colours.plp.filters.clearBtnBorderWidth};
        border-radius: ${({theme}) => theme.colours.form.buttonPrimary.radius};
        &:hover {
            background-color: ${props =>
                props.large ? (props.theme.colours.form.buttonPrimary.background as string) : "transparent"};
            border-radius: ${({theme}) => theme.colours.form.buttonPrimary.radius};
        }
        &:focus {
            border: none;
            border-radius: ${({theme}) => theme.colours.form.buttonPrimary.radius};
        }
        &:active {
            background-color: ${props =>
                props.large ? (props.theme.colours.form.buttonPrimary.background as string) : "transparent"};
            border: ${props => props.theme.colours.plp.filters.clearBtnBorderWidth};
            border-radius: ${({theme}) => theme.colours.form.buttonPrimary.radius};
        }
        ${props =>
            props.large &&
            `
                justify-content: center;
                text-align: center;
                padding: 0.56rem 0.75rem 0.5rem 0.75rem;
                letter-spacing: 0.054rem;`}
    }
`
